import { useQuery as useApolloQuery } from "@apollo/client";
import { getProviderQuery } from "@/graphql/queries";

type UseProviderNameProps = {
  providerId?: string | null;
};

export function useProviderName(props: UseProviderNameProps) {
  const { providerId } = props;

  const { data, loading } = useApolloQuery(getProviderQuery, {
    variables: { id: providerId || "" },
    skip: !providerId,
  });

  return {
    loading,
    providerName: data?.getProvider.name,
  };
}
